// src/components/PeoplePlan/TheBench/components/WorkflowControls/StatusFilters.js
import React from "react";

const StatusFilters = ({ selectedStatuses, onStatusChange }) => {
  const statuses = ["All statuses", "New", "In Progress", "Completed", "Rejected"];

  const renderCheckbox = (status) => {
    const isChecked = selectedStatuses.includes(status);
    return (
      <label key={status}>
        <input
          type="checkbox"
          checked={isChecked}
          onChange={(e) => onStatusChange(status, e.target.checked)}
        />
        {status}
      </label>
    );
  };

  return (
    <div className="bench-status-filters">
      {statuses.map(renderCheckbox)}
    </div>
  );
};

export default StatusFilters;